/**
 * Your positions: /tools/positions (docs/POSITIONS.md).
 *
 * A round is a few moments of the user's own games, one exercise at a time; the board is a session of its own
 * (`boards.positions`) and the engine is the service. This is what the page shows about where the round is.
 */
export const positionsSlice = {
    // loading | signedOut | picker | question | thinking | playing | answered | roundOver
    status: "loading",
    summary: null,        // ExerciseCount[] once read
    exercise: "find",
    phase: null,          // the phase of the game the round is narrowed to, or null for all
    withClock: false,     // "keep the advantage" with the clock the user had in the game
    round: [],            // the moments of this round, in order
    index: 0,
    setUp: null,          // the position of the moment being asked
    answer: null,         // what the answer was worth, once given
    results: [],          // one per moment answered this round
    convert: null,        // { pliesLeft, partner, clockMs } while keeping an advantage
    exploring: false,     // the board moved away from the moment, after answering, to look around
    attempt: null,        // the last try that was not the best, while another is allowed
    askedAt: null,        // when the question was put: the panel counts the thinking from it
    xp: 0,
    error: null,
};
